/*****
 * Created with vscode
 * Name : 吸顶提示信息
 * Date : 2020/3/2
 * Author : Bevis Shen
 * Func :
 *  text: 文案信息
 ******/

<template>
  <div v-show="showTip">
    <div class="consult-tip">
      <span>{{text}}</span>
      <i @click="hideTip"></i>
    </div>
    <div class="consult-blank"></div>
  </div>
</template>

<script>
export default {
  name: 'ConsultTip',
  props: {
    text: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      showTip: true
    }
  },
  methods: {
    hideTip () {
      this.showTip = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/ConsultTip.vue